import type { MessageKey } from '@/lib/i18n/messages/en'
import { isReservedWord } from '@/lib/reserved-words'

export const SLUG_MAX_LEN = 63

export interface SlugProblem {
  key: MessageKey
  params?: Record<string, unknown>
}

/** Mirrors `Slug::new` (B5) plus the reserved list (D9); the backend stays the authority. */
export function slugProblem(value: string): SlugProblem | undefined {
  if (value === '') return { key: 'slug.empty' }
  if ([...value].length > SLUG_MAX_LEN) return { key: 'slug.tooLong', params: { max: SLUG_MAX_LEN } }
  if (!/^[a-z0-9-]*$/.test(value)) return { key: 'slug.forbiddenChar' }
  if (value.startsWith('-') || value.endsWith('-')) return { key: 'slug.edgeHyphen' }
  if (value.includes('--')) return { key: 'slug.doubleHyphen' }
  if (isReservedWord(value)) return { key: 'error.SLUG_RESERVED' }
  return undefined
}

/** A first draft from a name: diacritics stripped (đ → d), everything else becomes a hyphen. */
export function slugify(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/gi, 'd')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, SLUG_MAX_LEN)
    .replace(/-+$/, '')
}
